module.exports = __webpack_public_path__ + "img/homeBuilding.802ec15b.jpg";